import styled from "styled-components";
import css from "@styled-system/css";
import {
  PositionProps,
  position,
  variant,
  layout,
  space,
  SpaceProps,
  LayoutProps,
} from "styled-system";

import variants from "./variants";
import Typography from "../Typography/Typography";

interface BoxProps extends PositionProps, SpaceProps, LayoutProps {
  /**
  Available sizes: "small"
   */
  variant?: "small";
}

export interface LotNumberBoxProps extends BoxProps {
  /**
  Lot number.
  */
  lotNumber: string;
  /**
  Available sizes: "small"
   */
  variant?: "small";
}

const LotNumberBox = styled.div<BoxProps>`
  box-sizing: border-box;
  text-transform: uppercase;
  background-color: rgba(255, 255, 255, 0.3);
  ${css({
    borderRadius: 1,
  })}

  ${position};
  ${space};
  ${layout};
  ${variant({
    variants,
  })};
`;

export default function LotNumber({
  lotNumber,
  variant = "small",
  ...props
}: LotNumberBoxProps) {
  return (
    <LotNumberBox
      minWidth={68}
      minHeight={25}
      variant={variant}
      aria-label="chip"
      {...props}
    >
      <Typography
        variant="body-small"
        fontWeight="medium"
        color="text-color-over-background"
        textAlign="center"
        margin={0}
      >
        {lotNumber}
      </Typography>
    </LotNumberBox>
  );
}
